import { createContext, useContext, useEffect, useState } from "react";
import { cachedGet } from "@/lib/api";

export const DEFAULT_SETTINGS = {
  whatsapp_number: "5521982430311",
  whatsapp_display: "(21) 98243-0311",
  store_slogan: "Entrega rápida em todo o RJ",
  footer_about:
    "Distribuidora online de móveis com entrega em diversas regiões do Rio de Janeiro. Qualidade, preço justo e o atendimento próximo que a sua casa merece.",
  footer_location: "Base em Nova Iguaçu/RJ — entregamos em várias cidades da região.",
  payment_note: "Pagamento na entrega: PIX, dinheiro, débito ou crédito em até 12x sem juros.",
  instagram_url: "",
  facebook_url: "",
  company_domain: "comprenahg.com.br",
  warranty_text: "Garantia: 3 meses (90 dias).\nTodos os produtos possuem garantia legal de 90 dias, conforme as condições previstas no Código de Defesa do Consumidor.",
  assembly_text: "Produto entregue desmontado, com manual e ferragens inclusos.",
  delivery_text: "Entrega própria HG Móveis, de segunda a sábado, em horário comercial. A data solicitada é confirmada pela nossa equipe.",
  maintenance_mode: false,
  payment: {
    pix: true,
    cash: true,
    debit: true,
    credit: true,
    debit_price_rule: "cash",
    combined_enabled: true,
    default_installments: 12,
  },
  shipping: {
    default_fee: 49.99,
    promo_active: true,
    promo_fee: 49.99,
    promo_label: "Taxa promocional de entrega",
  },
  schedule: {
    min_days: 1,
    capacity_per_day: 10,
    allowed_weekdays: [0, 1, 2, 3, 4, 5],
    blocked_dates: [],
  },
};

const SettingsContext = createContext(DEFAULT_SETTINGS);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    // cache de 60s evita a chamada dupla do StrictMode e repetições na mesma visita
    cachedGet("/settings/public")
      .then((data) => setSettings({ ...DEFAULT_SETTINGS, ...data }))
      .catch(() => {});
  }, []);

  // aplica os interruptores de animação do painel como classes no <body> (CSS puro, sem JS por frame)
  useEffect(() => {
    const a = settings.animations || {};
    const cls = document.body.classList;
    cls.toggle("no-anim", a.enabled === false);
    cls.toggle("anim-off-product-hover", a.enabled !== false && a.product_hover === false);
    cls.toggle("anim-off-buttons", a.enabled !== false && a.button_effects === false);
    cls.toggle("anim-off-menu", a.enabled !== false && a.menu_transitions === false);
    cls.toggle("anim-off-popup", a.enabled !== false && a.popup_animation === false);
    cls.toggle("anim-off-banner", a.enabled !== false && a.banner_transitions === false);
  }, [settings.animations]);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
